"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = new RegExp(/[\u30A0-\u30FF]/);

exports.default = _default;
module.exports = exports.default;